
'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

// NOTE: This is a deterrent only, not real security. DevTools can still be opened via browser menus, extensions, or by disabling JS.
export default function AntiInspect() {
  const pathname = usePathname();

  useEffect(() => {
    // Do not apply to admin or internal routes
    if (pathname?.startsWith('/admin') || pathname?.startsWith('/internal')) {
      return;
    }

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
      }

      // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C
      if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C' || e.key === 'i' || e.key === 'j' || e.key === 'c')) {
        e.preventDefault();
      }

      // Ctrl+U (View Source)
      if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [pathname]);

  return null;
}
